import React from "react";
import type { ToolkitAction } from "src/state/toolkitReduxStore";
import { RandomDisplay } from "./RandomDisplay";
import { chooseRandomStudent, displayStudent } from "src/pods/random";
import { useToolkitRandomStore } from "src/pods/random/toolkitRandomStore";
import { displayClose } from "src/pods/realtime";
import { shareOverWire } from "src/pods/realtime/index";
import { Student } from "src/pods/students";
import PresentationPage from "src/shared/components/PresentationPage";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";

type RandomDisplayContainerProps = {
  // from random pod
  student: Student;
  students: Student[];
  previouslyChosenStudents: Student[];
  shareOverWire: (action: ToolkitAction) => void;
  isRestart?: boolean; // what is this being used for?
  displayClose: () => void;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
class Container extends React.Component<Partial<RandomDisplayContainerProps>> {
  render() {
    return (
      <PresentationPage variant="random" onRequestHide={this.props.displayClose}>
        <RandomDisplay
          fullscreen={true}
          displayRandomStudent={this.displayRandomStudent}
          student={this.props.student}
          students={this.props.students}
          isRestart={this.props.isRestart}
        />
      </PresentationPage>
    );
  }

  displayRandomStudent = () => {
    const chosenStudent = chooseRandomStudent(this.props.students, this.props.previouslyChosenStudents);
    const action: ToolkitAction = displayStudent(this.props.students, chosenStudent);
    this.props.shareOverWire?.(action);
  };
}

export function RandomDisplayContainer() {
  const randomState = useToolkitRandomStore();
  const mutableStudents = randomState.students ? [...randomState.students] : undefined;
  const mutablePreviouslyChosenStudents = randomState.previouslyChosenStudents
    ? [...randomState.previouslyChosenStudents]
    : undefined;

  return (
    <Container
      {...randomState}
      students={mutableStudents}
      previouslyChosenStudents={mutablePreviouslyChosenStudents}
      displayClose={() => dispatchToolkitReduxAction(displayClose())}
      shareOverWire={(action) => dispatchToolkitReduxAction(shareOverWire(action))}
    />
  );
}
